import {getAllSelectedItemObjectsOnCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {useAppSelector} from '@/hooks';

export function useShouldDisableGroupMovementOptions(): boolean {
  const selectedItemObjects = useAppSelector(getAllSelectedItemObjectsOnCurrentPage);

  for (const selectedItemObject of Object.values(selectedItemObjects)) {
    if (selectedItemObject.lockMovementX) {
      return true;
    }
  }

  return false;
}
